import React, { FC } from 'react';
import payFeeUrl from '@/assets/home/image 162@2x.png';
import parkingFeeUrl from '@/assets/home/image 161@2x.png';
import topUpFeeUrl from '@/assets/home/image 163@2x.png';
import warrantyUrl from '@/assets/home/image 164@2x.png';
import guideUrl from '@/assets/home/image 165@2x.png';
import announcementUrl from '@/assets/home/image 166@2x.png';
import moreUrl from '@/assets/home/image 167@2x.png';
import homeUrl from '@/assets/home/image168.png';
import styles from './index.less';

export type QuickOperationListType = {
  label: string;
  icon: string;
  redirectUrl: string;
};

interface QuickOperationProps {
  quickClick: (value: string) => void;
}

const QuickOperation: FC<QuickOperationProps> = (props) => {
  const { quickClick } = props;
  const quickOperationList: QuickOperationListType[] = [
    { label: '生活缴费', icon: payFeeUrl, redirectUrl: '/account/bill' },
    { label: '社区资讯', icon: parkingFeeUrl, redirectUrl: '/wechatNews' },
    { label: '公告公示', icon: topUpFeeUrl, redirectUrl: '/announcement' },
    { label: '报事报修', icon: warrantyUrl, redirectUrl: '' }, // /repairManage
    { label: '问卷调查', icon: guideUrl, redirectUrl: '/questionnaire' },
    { label: '社区活动', icon: homeUrl, redirectUrl: '/wechatActivity' },
    { label: '投票', icon: announcementUrl, redirectUrl: '/vote' },
    { label: '更多', icon: moreUrl, redirectUrl: '/servicesMore' },
  ];

  return (
    <div className={styles['quick-operation-container']}>
      {quickOperationList.map((item) => (
        <div onClick={() => quickClick(item.redirectUrl)} key={item.label}>
          <img src={item.icon} alt={item.label} />
          <p>{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickOperation;
